import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import style from './page-loading.module.scss.js';

const PageLoading = () => {
  const label = useLabel();
  return jsxs("div", {
    className: getClassNames(style.container),
    children: [jsx("div", {
      className: style.title,
      children: label('llm.thinking')
    }), jsxs("div", {
      className: style.loading,
      children: [jsx("span", {
        children: "\u00A0"
      }), jsx("span", {
        children: "\u00A0"
      }), jsx("span", {
        children: "\u00A0"
      })]
    })]
  });
};

export { PageLoading };
//# sourceMappingURL=page-loading.js.map
